import { SeoEnricherIntent } from '../../constants/seoEnricherIntents';

const ICON_BASE_PATH = '/seo-enricher-icons';

export const SEO_ENRICHER_DEFAULT_ICON = `${ICON_BASE_PATH}/default.svg`;

export const SEO_ENRICHER_INTENT_ICON_PATHS: Record<
  SeoEnricherIntent,
  string
> = {
  pricing_fare: `${ICON_BASE_PATH}/pricing_fare_v3.svg`,
  fare_inclusions: `${ICON_BASE_PATH}/fare_inclusions_v3.svg`,
  booking_process: `${ICON_BASE_PATH}/booking_process_v3.svg`,
  booking_modification: `${ICON_BASE_PATH}/modify_cab_v3.svg`,
  cab_type_selection: `${ICON_BASE_PATH}/cab_type_selection_v3.svg`,
  luggage_capacity: `${ICON_BASE_PATH}/luggage_capacity_v3.svg`,
  route_distance_duration: `${ICON_BASE_PATH}/multicity_v3.svg`,
  toll_charges: `${ICON_BASE_PATH}/pricing_fare_v3.svg`,
  night_travel: `${ICON_BASE_PATH}/night_travel_v3.svg`,
  airport_transfer: `${ICON_BASE_PATH}/airport_transfer_v3.svg`,
  sightseeing_tourism: `${ICON_BASE_PATH}/sightseeing_tourism_v3.svg`,
  safety_comfort: `${ICON_BASE_PATH}/safety_comfort_v3.svg`,
  cancellation_refund: `${ICON_BASE_PATH}/cancellation_refund_v3.svg`,
  waiting_time_policy: `${ICON_BASE_PATH}/waiting_time_policy_v3.svg`,
  multi_stop_trip: `${ICON_BASE_PATH}/multicity_v3.svg`,
  cab_comparison: `${ICON_BASE_PATH}/cab_comparison_v3.svg`,
  group_travel: `${ICON_BASE_PATH}/group_travel_v3.svg`,
  driver_quality: `${ICON_BASE_PATH}/driver_quality_v3.svg`,
  driver_cab_assignment: `${ICON_BASE_PATH}/guaranteed_on_time_v3.svg`,
  payment_options: `${ICON_BASE_PATH}/payment_options_v3.svg`,
  general_inquiry: `${ICON_BASE_PATH}/general_inquiry_v3.svg`
};

export const CIRCLE_INFO_ICON_PATH = `${ICON_BASE_PATH}/circle_info_v2.svg`;
export const getSeoEnricherIntentIconPath = (
  intent: SeoEnricherIntent | null
) =>
  intent ? SEO_ENRICHER_INTENT_ICON_PATHS[intent] : SEO_ENRICHER_DEFAULT_ICON;
